<jjames-card>
    <div class="p-6">
        <h2 class="text-2xl font-semibold text-gray-800 mb-2">Create Infrastructure</h2>
        <p class="text-sm text-gray-600 mb-6">
            Define the infrastructure for the parking space <strong>{{ parkingSpace.name }}</strong>.
            You can skip this step and add it later.
        </p>
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <div class="grid grid-cols-1 gap-6">

                <!-- Name -->
                <mat-form-field appearance="fill">
                    <mat-label>Infrastructure Name</mat-label>
                    <input matInput formControlName="name" required>
                    @if (form.get('name')?.hasError('required')) {
                    <mat-error>Name is required</mat-error>
                    }
                </mat-form-field>

                <!-- Description -->
                <mat-form-field appearance="fill">
                    <mat-label>Description</mat-label>
                    <textarea matInput formControlName="description"></textarea>
                </mat-form-field>

            </div>

            <!-- Actions -->
            <div class="flex justify-end gap-4 mt-8">
                <button type="button" mat-stroked-button (click)="onSkip()">
                    Skip
                </button>
                <button type="submit" mat-flat-button color="primary" [disabled]="isSaving()">
                    @if (!isSaving()) {
                    <span>Create and Continue</span>
                    }
                    @if (isSaving()) {
                    <span>Creating...</span>
                    }
                </button>
            </div>
        </form>
    </div>
</jjames-card>